<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeInformation from "@dsk/icons/LeInformation.vue";

import { vMatomoEvent } from "@/directives";
import { DictionariesHelper, NgModalHelper } from "@/helpers";
import { type Dictionary, MatomoEventAction, MatomoEventCategory } from "@/types";

const props = defineProps<{
  dictionary: Dictionary;
  tooltip: string;
}>();

const showAboutDictionary = () => {
  const dictionaryId = props.dictionary.id;
  const publisher = dictionaryId.split("-")[0];

  NgModalHelper.open(`dictionaries/${publisher}/${dictionaryId}`);
};
</script>

<template>
  <LeTooltip v-if="DictionariesHelper.hasAboutDictionary(props.dictionary)" :text="props.tooltip" :margin-bottom="10">
    <LeIconButton
      v-matomo-event:click="{
        category: MatomoEventCategory.Search,
        action: MatomoEventAction.ClickSearchToolboxIcon,
        label: 'Clicked about dictionary icon'
      }"
      size="l"
      :aria-label="props.tooltip"
      @click="showAboutDictionary()"
    >
      <LeInformation role="presentation"></LeInformation>
    </LeIconButton>
  </LeTooltip>
</template>
